import { JSX, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import ResumeApplicationPageView from '@components/ResumeApplicationPageView';
import Spinner from '@components/Spinner';
import useApiClient from '@hooks/useApiClient';

function ResumeApplicationPage(): JSX.Element {
  const router = useRouter();
  const [checkedSessionExists, setCheckedSessionExists] = useState(false);
  const apiClient = useApiClient();

  useEffect(() => {
    async function check(): Promise<void> {
      try {
        const {
          data: { profile },
        } = await apiClient.me();

        if (profile) {
          // If authenticated, take them back to the home page.
          router.push('/');
        }
      } catch (error) {
        // User is not authenticated. Don't do anything.
      } finally {
        setCheckedSessionExists(true);
      }
    }

    if (!checkedSessionExists) {
      check();
    }
  }, [checkedSessionExists, apiClient, router]);

  if (!checkedSessionExists) {
    return (
      <div className="flex flex-row justify-center">
        <Spinner />
      </div>
    );
  }

  return <ResumeApplicationPageView />;
}

export default ResumeApplicationPage;
